import { render, staticRenderFns } from "./MilestoneForm.vue?vue&type=template&id=4577faf4&"
import script from "./MilestoneForm.vue?vue&type=script&lang=js&"
export * from "./MilestoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports